import { safeJsonLd } from '@/lib/json-ld'

/** Shared server-rendered schema boundary; callers supply data, never HTML. */
export function JsonLdScript({ data, id }: { data: unknown; id?: string }) {
  return <script id={id} type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJsonLd(data) }} />
}
